import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faBolt,
  faBuilding,
  faCaretDown,
  faClock,
  faCopy,
  faDownload,
  faEdit,
  faEllipsisV,
  faExternalLinkAlt,
  faFileCsv,
  faFileExport,
  faFilterCircleXmark,
  faFont,
  faGlobe,
  faHashtag,
  faLevelUpAlt,
  faLock,
  faPlus,
  faSave,
  faStar,
  faSync,
  faTable,
  faThumbtack,
  faTimesCircle,
  faTrash,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';

/**
 * Every icon the kit's own templates reference by name (`['fas', 'star']`).
 * DataGridModule registers them in the FontAwesome library, so a consumer that
 * never registers the solid pack still renders the grid chrome. Icons a host
 * passes in (`icon`, column icons) remain the host's to register.
 */
export const GRID_ICONS: IconDefinition[] = [
  faBolt,
  faBuilding,
  faCaretDown,
  faClock,
  faCopy,
  faDownload,
  faEdit,
  faEllipsisV,
  faExternalLinkAlt,
  faFileCsv,
  faFileExport,
  faFilterCircleXmark,
  faFont,
  faGlobe,
  faHashtag,
  faLevelUpAlt,
  faLock,
  faPlus,
  faSave,
  faStar,
  faSync,
  faTable,
  faThumbtack,
  faTimesCircle,
  faTrash,
  faXmark,
];
